export const OVERLAY_ROOT_ATTRIBUTE = 'data-overlay-root';
export const OVERLAY_ROOT_NAME = 'app-overlays';
export const OVERLAY_ROOT_SELECTOR = `[${OVERLAY_ROOT_ATTRIBUTE}="${OVERLAY_ROOT_NAME}"]`;

export const getOverlayPortalRoot = (document_?: Document | null): Element | undefined => {
  const targetDocument = document_ ?? globalThis.document ?? null;

  if (!targetDocument) {
    return;
  }

  return targetDocument.querySelector(OVERLAY_ROOT_SELECTOR) ?? targetDocument.body;
};

export const overlayRootAttributes = {
  [OVERLAY_ROOT_ATTRIBUTE]: OVERLAY_ROOT_NAME,
} as const;
